export default "__VITE_ASSET__0e10bb00__"